import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isPlainObject from 'lodash/isPlainObject';

import { CommonApiResponseType } from 'src/models/BaseApi';

/**
 * recursively check is response valid
 * returns false when finds a first error
 */
export const isHttpResponseValid = (response: CommonApiResponseType | null): boolean => {
  if (isArray(response) && response.length === 0) {
    return true;
  }
  // in case if response is an empty object (see TaskStatusExportCampaignReturnType)
  // or boolean (see campaignExportStatusReturnType)
  if ((isEmpty(response) && isPlainObject(response)) || response === true || response === false || isNumber(response)) {
    return true;
  }
  if (!response || isEmpty(response)) {
    return false;
  }

  const arr = Object.entries(response);

  for (let i = 0; i < arr.length; i += 1) {
    const [key, value] = arr[i];

    if (key === 'hasErrors') {
      if (value === 'true') {
        return false;
      }
      if (typeof response.hasErrors === 'function') {
        return !response.hasErrors();
      }
    } else if (isPlainObject(value) && !isHttpResponseValid(value)) {
      return false;
    } else if (isArray(value) && !isHttpResponseValid(value)) {
      return false;
    }
  }

  return true;
};

/**
 * choose the way where to go depending on response
 */
export const httpResponseEither =
  <T>(right: (res: T) => void, left: (res: T) => void) =>
  (response: T): void => {
    // eslint-disable-next-line no-unused-expressions
    isHttpResponseValid(response) ? right(response) : left(response);
  };
